<!--
create by melody on 2018/11/1
description:用户信息
-->
<template>
    <div>
        <page-header :title="title"></page-header>
        <div class="info-container">
            <el-row :gutter="24" v-for="(item,index) in infoList" :key="index">
                <el-col :span="9"><div class="text-right" v-html="item.name"></div></el-col>
                <el-col :span="10"><div class="">{{item.value}}</div></el-col>
                <!-- <el-col :span="5"><div class="btn-style" v-on:click="clickBtn(item.btnType)">{{item.btn}}</div></el-col> -->
            </el-row>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            title:{
                firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.ACCOUT_MANAGE'),
                thirdTitle: this.$t('m.USER_INFO')
            },
            infoList:[],
        }
    },
    methods: {
        resData2() {
            let userInfoObj = this.$store.state.userInfo.userInfoObj
            let roleName = userInfoObj.roleList[0].roleName
            this.infoList = [{
                name:this.$t('m.userName') + " :",
                value:userInfoObj.userName
            },{
                name:this.$t('m.roleName') + " :",
                value:roleName
            },{
                name:this.$t('m.email') + " :",
                value:userInfoObj.userEmail
            },{
                name:this.$t('m.mobileNumber') + " :",
                value:userInfoObj.userMobile
            }]
        }
    },
    mounted() {
        this.resData2()
    }
}
</script>
<style scoped>
.info-container {
    width: 600px;
    margin: 80px auto;
    color: rgb(44, 62, 80);
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
}
.text-right {
    text-align: right;
}

.grid-content {
    /*border-radius: 4px;*/
    min-height: 36px;
}
.btn-style {
    color: blue;
    cursor: pointer
}
</style>


// WEBPACK FOOTER //
// src/pages/account/UserInfo.vue